import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';
import { CardTitle } from '../../components/CardTitle';

import { allProductsState } from '../../recoil/atoms';
import { assetPathFn } from '../../util';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import styles from './SilhouetteBraLanderMobile.module.scss';
import { useLanderControls } from '../LanderContext';

export const SilhouetteBraLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero heroImage={'mobile-silhouette-bra-lander-top-hero-1.jpg'} title={'Silhouette Bra'} subTitle={'Style, support, and comfort in harmony.'}>
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Adjustable <br />
                straps
              </>
            }
            inlineStyles={{
              mobile: {
                left: `58%`,
                top: `38%`,
                flexDirection: 'row-reverse',
                alignItems: 'flex-start',
              },
            }}
          />
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Soft <br />
                Removable
                <br /> cups
              </>
            }
            titleStyles={{ textAlign: 'center', lineHeight: '22px', marginTop: 12 }}
            inlineStyles={{
              mobile: {
                right: `52.5%`,
                top: `56%`,
                flexDirection: 'column-reverse',
                alignItems: 'center',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={
              <>
                Wire-free
                <br />
                support
              </>
            }
            titleStyles={{ lineHeight: '22px' }}
            inlineStyles={{
              mobile: {
                right: `16.5%`,
                top: `80%`,
                flexDirection: 'row-reverse',
                alignItems: 'center',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-sb-desktop-1.jpg',
              title: '3D velvet contouring',
              description: 'Bonded velvet piping adds structure, shape, and style.',
            },
            {
              imgName: 'feature-sb-desktop-2.jpg',
              title: 'Underwire-free lift',
              description: 'Bonding at the cradle lifts your chest for a supportive, comfortable lift. ',
            },
            {
              imgName: 'feature-sb-desktop-3.jpg',
              title: 'Fully adjustable',
              description: 'Adjust the length of your straps, or cross them in the back for support.',
            },
          ]}
        />
        <CardTitle text="Pretty and powerful." style={{ padding: '50px 0', paddingTop: 0, maxWidth: '100%' }} type={'capital'} />
        <div className={styles.comparison}>
          <img src={assetPathFn('bra-before-after.jpg')} alt="comparison" />
          <div>
            <div>competitor</div>
            <div>
              silhouette <br />
              bra
            </div>
          </div>
        </div>
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.SilhouetteBra]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default SilhouetteBraLanderMobile;
